import React from "react";
import {withTranslation} from "react-i18next";
import CheckBox from "../../../../../../../components/checkbox/CheckBox";
import stylesWelcome from "../SchedaSpecialeMIB.module.css";
import Utils from "../../../../../../../utils/Utils";

class CheckBoxTable extends React.Component {

    constructor(props) {
        super(props);
        this.createCheckBoxTable = this.createCheckBoxTable.bind(this)
        this.controlloCheck = this.controlloCheck.bind(this)
        this.riceviValore = this.riceviValore.bind(this)
    }

    controlloCheck(field, row) {
        let stato = this.props.stato
        let id = this.props.id
        let rowCheck = this.props.row
        let rowList = this.props.rowList

        if (id === "") {
            if (rowList) {
                id = field
                stato[rowList[row] + row] = false
                rowList[row] = field;

            } else {
                id = rowList[row]
                rowCheck = row
            }
        }

        if (field !== id && rowCheck === row) {
            stato[id + row] = false
            rowList[row] = field;
        } else if (field != id && rowCheck != row && rowList != []) {
            stato[rowList[row] + row] = false
            rowList[row] = field;
        }

        return this.props.setStatePadre({diagnosiInfluenza: stato, id: field, row: row, rowList: rowList})

    }

    riceviValore(field, event) {
        let stato = this.props.stato
        if (event.target.value === "true") {
            stato[field] = true;
        } else if (event.target.value === "false") {
            stato[field] = false;
        } else {
            stato[field] = event.target.value
        }

        this.props.setStatePadre({diagnosiInfluenza: stato})
    }


    createCheckBoxTable() {
        let boxes = []
        let rows = this.props.rows
        let row = {}
        let col1 = {}
        let col2 = {}
        let col3 = {}
        let col4 = {}
        let col5 = {}
        const {t} = this.props;

        for (let i = 0; i < rows.length; i++) {
            for (let key in rows[i]) {
                if (this.props.stato[rows[i][key].id] && rows[i][key].radio && this.props.rowList) {
                    if (this.props.rowList[rows[i][key].row] !== rows[i][key].radio) {
                        let rowList = this.props.rowList;
                        rowList[rows[i][key].row] = rows[i][key].field
                    }
                }
                let checkBox = (
                    <CheckBox
                        id={rows[i][key].id}
                        field={rows[i][key].field}
                        disabled={this.props.disabled}
                        checked={this.props.stato[rows[i][key].id]}
                        text={t(rows[i][key].text)}
                        onChange={this.riceviValore}
                        onClick={
                            rows[i][key].radio ? () => this.controlloCheck(rows[i][key].field, rows[i][key].row) : ""
                        }
                        newCheckbox={true}
                    >
                    </CheckBox>
                )
                if (rows[i][key].numeroCol === 1) {
                    col1 = (
                        <div className={"col-lg-4"}>
                            {checkBox}
                        </div>
                    )
                } else if (rows[i][key].numeroCol === 2) {
                    col2 = (
                        <div className={"col-lg-1"}>
                            {checkBox}
                        </div>
                    )
                } else if (rows[i][key].numeroCol === 3) {
                    col3 = (
                        <div className={"col-lg-2"}>
                            {checkBox}
                        </div>
                    )
                } else if (rows[i][key].numeroCol === 4) {
                    col4 = (
                        <div className={"col-lg-1"}>
                            {checkBox}
                        </div>
                    )
                } else if (rows[i][key].numeroCol === 5) {
                    col5 = (
                        <div className={"col-lg-4"}>
                            {checkBox}
                        </div>
                    )
                }
            }
            row = (
                <div>
                    <div className={"row"}>
                        {Utils.isEmpty(col1) ? <div className={"col-lg-4"}></div> : col1}
                        {Utils.isEmpty(col2) ? <div className={"col-lg-1"}></div> : col2}
                        {Utils.isEmpty(col3) ? <div className={"col-lg-2"}></div> : col3}
                        {Utils.isEmpty(col4) ? <div className={"col-lg-1"}></div> : col4}
                        {Utils.isEmpty(col5) ? <div className={"col-lg-4"}></div> : col5}
                    </div>
                </div>

            )
            col1 = col2 = col3 = col4 = col5 = {}
            boxes.splice(i, 0, row)
        }

        return boxes;
    }

    render() {

        const {t} = this.props;
        let boxes = this.createCheckBoxTable()

        const sezione1 = (

            <div>
                <div className="col-lg-4" style={{marginTop: "1rem"}}>
                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                        {t(this.props.intestazione)}
                        {this.props.malattiaBatterica === this.props.tipoMalattiaBattareica ?
                            <span className={stylesWelcome.mandatoryColor}>*</span> : ""}
                    </p>
                </div>
            </div>
        );

        return (
            <div className={"container"}>
                {sezione1}
                {boxes}
            </div>
        )
    }


}

export default withTranslation('common')(CheckBoxTable)
